import {Link, Navigate, Route, Routes} from "react-router";
import {PageIndex} from "./pages/PageIndex";
import {PageFavorites} from "./pages/PageFavorites";
import React from "react";
import {PageMap} from "./pages/PageMap";
import {PageObject} from "./pages/PageObject";
import {PageObjectPlan} from "./pages/PageObjectPlan";
import {PageObjectMap} from "./pages/PageObjectMap";

const Page404 = () => <div style={{padding:"1rem"}}>
  <h1>404, TODO: make it nicer 😜</h1>
  <Link to="/storefront">Повернутися на головну...</Link>
</div>

export function Routing () {
  return <Routes>
    <Route path="/" element={<Navigate replace to="/storefront" />}/>
    <Route path="storefront/*">
      <Route index element={<PageIndex/>}/>
      <Route path="fav" element={<PageFavorites/>}/>
      <Route path="map"  element={<PageMap/>}/>
      <Route path=":object_name"  element={<PageObject/>}/>
      <Route path=":object_name/plan"  element={<PageObjectPlan/>}/>
      <Route path=":object_name/map"  element={<PageObjectMap/>}/>
      <Route path=":object_name/fav"  element={<PageFavorites/>}/>
      <Route path="*" element={<Page404/>}/>
    </Route>
    <Route path="*" element={<Page404/>}/>
  </Routes>
}